import { MosacFilterTransaction } from '../transaction/mosaic-filter.transaction';
import { MetadataTransaction } from '../transaction/metadata.transaction';

export const CATAPULT_TRANSACTION_PROVIDERS = [
	MosacFilterTransaction,
	MetadataTransaction
];
